<template>
 <div>
      <!-- <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    > -->
    <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe @row-dblclick="handleCheckDeliverGoods">
    <el-table-column prop="deliveryCode" label="发货单号"> </el-table-column>
    <el-table-column prop="custOrderNum" label="客户订单号"> </el-table-column>
    <el-table-column prop="orderNum" label="IMS订单号"> </el-table-column>
    <el-table-column prop="customerName" label="下单客户名"> </el-table-column>
    <el-table-column prop="invoiceCustomerName" label="开票客户名"> </el-table-column>
    <el-table-column prop="orderTypeName" label="订单类型"> </el-table-column>
    <el-table-column prop="orgName" label="账套"> </el-table-column>
    <el-table-column prop="deliveryOrgName" label="库存组织"> </el-table-column>
    <el-table-column prop="salesType" label="销售类别"> </el-table-column>
    <el-table-column prop="contains" label="形式"> </el-table-column>
    <el-table-column prop="priceListName" label="价格单"> </el-table-column>
    <el-table-column prop="planCaseQty" label="箱数"> </el-table-column>
    <el-table-column prop="netWeight" label="重量"> </el-table-column>
    <el-table-column prop="apportionNetWeight" label="过磅重量"> </el-table-column>
    <el-table-column prop="businessDiscount" label="商业折扣类型"> </el-table-column>
    <el-table-column prop="tradeDiscountAmount" label="商业折扣额"> </el-table-column>
    <el-table-column prop="marketDiscountAmount" label="市场折扣额"> </el-table-column>
    <el-table-column prop="totalExpAmount" label="费用"> </el-table-column>
    <el-table-column prop="totalAmount" label="总计金额"> </el-table-column>
    <el-table-column prop="amount" label="合计净额"> </el-table-column>
    <el-table-column prop="contractNumber" label="合同号"> </el-table-column>
    <el-table-column prop="rejectInformId" label="项目销售费用"> </el-table-column>
    <el-table-column prop="expectedDate" label="要求发货日期"> </el-table-column>
    <el-table-column prop="exportConfirmDate" label="出库日期"> </el-table-column>
    <el-table-column prop="orderCreator" label="制单人"> </el-table-column>
    <el-table-column prop="tel" label="联系电话"> </el-table-column>
    <el-table-column prop="transportTypeName" label="承运方式"> </el-table-column>
    <el-table-column prop="vehicleBrand" label="车号"> </el-table-column>
    <el-table-column prop="vehicleLinkman" label="物流业务员"> </el-table-column>
    <el-table-column prop="vendorTel" label="物流业务电话"> </el-table-column>
    <el-table-column prop="freightTermName" label="承担运费方"> </el-table-column>
    <el-table-column prop="planDeliveryDate" label="计划发运日期"> </el-table-column>
    <el-table-column prop="packingOrderFlag" label="派车"> </el-table-column>
    <el-table-column prop="inFactory" label="进厂"> </el-table-column>
    <el-table-column prop="outFactory" label="出厂"> </el-table-column>
    <el-table-column prop="zaiTu" label="在途"> </el-table-column>
    <el-table-column prop="customerReceiveFlag" label="签收"> </el-table-column>
    <el-table-column prop="shdz" label="收货地址"> </el-table-column>
    <el-table-column prop="addressLinkManName" label="收货联系人"> </el-table-column>
    <el-table-column prop="deliveryRequest" label="发货要求"> </el-table-column>
    <el-table-column prop="remark" label="备注"> </el-table-column>
  </el-table>
  <el-pagination
    :current-page="pageNo"
    :page-size="pageSize"
    background
    layout="prev, pager, next, jumper"
    :total="rowCount"
    @current-change="handleCurrentChange"
  />
 </div>
</template>

<script>
export default {
  created() {
    this.getList()
  },
      methods:{
        getList() {
          this.$axios
            .postReq("/meide/REST/ajaxQueryOrderDetail", {
              postType: "queryDeliveryHeader",
              start: this.pageNo,
              limit: this.pageSize
            })
            .then((res) => {
              this.list = res.data;
              this.rowCount = res.rowcount;
            });
        },
        handleCurrentChange(val) {
          this.pageNo = val;
          this.getList();
        },
        handleCheckDeliverGoods(item) {
          const path = this.$router.resolve({
            name: "DeliverGoodsDetail",
            params:{
              id:item.deliveryId
            }
          });
          window.open(path.href, "_blank");
        },
    //       daochu() {
    // let invoiceSeq = this.$route.params.id;
    //   this.$axios
    //     .postReq("/meide/REST/ajaxOrderExport", {
    //       postType: "exportInvoiceDetail",
    //       invoiceSeq,
    //     })
    //     .then((res) => {
    //       if (res.success == "true") {
    //         let url = res.url;
    //         window.open(url);
    //       } else {
    //         // this.$message.error(res.ErrorText);
    //       }
    //     });
    // },
    },
  data() {
    return {
      list: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
    };
  },
};
</script>